
riot.tag2('recapture-script', '', '', '', function(opts) {
var recapturescript;

if (window.recapturescript != null) {
  return;
}

recapturescript = riot.observable();

recapturescript.one('loadscript', (function(_this) {
  return function() {
    var script;
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.onload = function() {
      return recapturescript.trigger('loaded');
    };
    return document.body.appendChild(script);
  };
})(this));

window.recapturescript = recapturescript;
});
riot.tag2('recapture', '<recapture-script></recapture-script> <div data-sitekey="{opts.sitekey}" class="g-recaptcha"></div>', '', '', function(opts) {
this.on('mount', function() {
  this.recapture = window.recapturescript;
  if (window.grecaptcha != null) {
    return this.load();
  } else if (this.recapture) {
    this.recapture.one('loaded', (function(_this) {
      return function() {
        return _this.load();
      };
    })(this));
    return this.recapture.trigger('loadscript');
  } else {
    throw new Error('ReCaptcha hasn\'t been loaded');
  }
});

this.callback = function() {
  console.log('successful');
  if (opts.ontoken != null) {
    return opts.ontoken();
  }
};

this.load = function() {
  return this.update();
};
});